import { useFrameDelivery } from './frameDelivery.hook.js';
import { useProjectionObserver } from './projectionObserver.hook.js';

/** Delivery scheduling and observation only; existing reducers own displayed data. */
export function useRealtimeDelivery({ enabled, observe, build, ready, getOwner, getSequence,
  getRows, apply, recover, frameRef, observerRef }) {
  const observer = useProjectionObserver({ enabled: observe, build, ready,
    getOwner: () => getOwner('list'), getSequence: () => getSequence('list'), getRows });
  observerRef.current = observer;
  const frame = useFrameDelivery({ enabled, getOwner, getSequence, recover,
    apply: (lane, envelope) => {
      const previous = getRows();
      const accepted = apply(lane, envelope);
      if (lane === 'list') observer.applied(envelope, getRows(), previous, accepted);
      return accepted;
    },
  });
  frameRef.current = frame;
  return { frame, observer };
}
